import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import changePassCss from "../styles/changepass.module.scss";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import changePassGIF from "../assets/Change Pass.gif";
import { RiLockPasswordFill } from "react-icons/ri";

function Changepass() {
  const [email, setEmail] = useState("");
  const { uid, token } = useParams();
  const [valid, setValid] = useState(false);

  useEffect(() => {
    document.body.style.background = "#000";
    async function tokenValidate() {
      let { data } = await axios.post(
        `https://chatwave-b-api.onrender.com/tokenValidate/${uid}/${token}`
      );
      if (!data.status) {
        document.querySelector("#root").innerHTML = "";
        document.querySelector("#root").innerHTML =
          "<h1 align='center' style='color:#fff;'>Token Expired</h1>";
      } else {
        setValid(true);
        setEmail(data.email);
      }
    }
    tokenValidate();
  }, [uid, token]);

  async function changePassValidate(e) {
    e.preventDefault();
    let { data } = await axios.post(
      `https://chatwave-b-api.onrender.com/tokenValidate/${uid}/${token}`
    );
    if (data.status === true) {
      let password = document.querySelector("#password");
      let cpassword = document.querySelector("#cpassword");
      let submitBtn = document.querySelector("button");

      submitBtn.style.pointerEvents = "none";
      submitBtn.textContent = "Changing...";

      if (password.value === cpassword.value) {
        let { data } = await axios.post(
          `https://chatwave-b-api.onrender.com/updatePass/${email}`,
          {
            newPass: password.value,
          }
        );
        if (data.status) {
          toast.success(data.message, { style: { fontFamily: "Poppins" } });
          document.querySelector("#root").lastElementChild.style.background =
            "#000";
          document.querySelector("#root").lastElementChild.style.alignItems =
            "center";
          document.querySelector(
            "#root"
          ).lastElementChild.innerHTML = `<h1 align="center" style="color:#fff;">Go To Login Page</h1>`;
        } else {
          toast.error(data.message, { style: { fontFamily: "Poppins" } });
        }
      } else {
        toast.error("Passwords Are Not Same", {
          style: { fontFamily: "Poppins" },
        });
        submitBtn.style.pointerEvents = "auto";
        submitBtn.textContent = "Change Password";
      }
    } else {
      toast.error(data.message, {
        style: { color: "#fff", fontFamily: "Poppins" },
      });
    }
  }
  return valid === true ? (
    <>
      <Toaster />
      <div className={changePassCss.changepassContainer}>
        <div className={changePassCss.changepasselements}>
          <div className={changePassCss.leftElements}>
            <img src={changePassGIF} alt="changepass-gif" />
          </div>
          <div className={changePassCss.rightElements}>
            <div className={changePassCss.changePassHeading}>
              <h1>Forgot Password</h1>
            </div>
            <form
              onSubmit={(e) => {
                changePassValidate(e);
              }}
            >
              <div className={changePassCss.inputs}>
                <div className={changePassCss.input}>
                  <RiLockPasswordFill />
                  <input
                    type="password"
                    name="password"
                    id="password"
                    placeholder="Password"
                    spellCheck="false"
                    autoCorrect="off"
                    required
                  />
                </div>
                <div className={changePassCss.input}>
                  <RiLockPasswordFill />
                  <input
                    type="password"
                    name="cpassword"
                    id="cpassword"
                    placeholder="Confirm Password"
                    spellCheck="false"
                    autoCorrect="off"
                    required
                  />
                </div>
              </div>
              <div className={changePassCss.submitBtn}>
                <button type="submit">Change Password</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  ) : (
    <h1 align="center" color="#fff">
      Token Expired
    </h1>
  );
}

export default Changepass;
